import { createNotification } from "react-redux-notify";
import { put, takeLatest, all } from "redux-saga/effects";

import api from "../../Environment";
import {
  GO_LIVE_START,
  FETCH_STREAMER_CHANNEL_START,
  FETCH_LIVE_STREAMING_CHANNEL_START,
  FETCH_LIVE_STREAMING_SUMMARY_START,
  FETCH_LIVE_STREAMING_CHANNELS_START,
  LIVE_STREAMING_CHANNEL_PAYMENT_START,
  FETCH_LIVE_PERFORMERS_START,
} from "../actions/ActionConstant";
import {
  goLiveSuccess,
  goLiveFailure,
  fetchStreamerChannelSuccess,
  fetchStreamerChannelFailure,
  fetchStreamingChannelFailure,
  fetchLivePerformersSuccess,
  fetchLivePerformersFailure,
  fetchStreamingChannelSuccess,
  setLiveStreamingChannelIsPaid,
  setLiveStreamingChannelMessages,
  fetchLiveStreamingSummarySuccess,
  fetchLiveStreamingSummaryFailure,
  fetchLiveStreamingChannelsSuccess,
  fetchLiveStreamingChannelsFailure,
  liveStreamingChannelPaymentFailure,
  liveStreamingChannelPaymentSuccess,
} from "../actions/LiveStreamingAction";
import {
  getErrorNotificationMessage,
  getSuccessNotificationMessage,
} from "../../components/helper/NotificationMessage";
import StreamingService from "../../helpers/services/streaming/channel";
import { parseStreamingServiceError } from "../../helpers/services/streaming/error";
import { showErrorComponent } from "../actions/ComponentAction";

function* goLive(action) {
  try {
    const { name, showCollectedTip, isCameraOff, isMuted, isChatDisabled } =
      action.data;
    const response = yield StreamingService.createChannel(
      name,
      showCollectedTip,
      isCameraOff,
      isMuted,
      isChatDisabled
    );

    yield put(goLiveSuccess(response));
    window.location.assign("/golive/" + response.id + "/streamer");
  } catch (error) {
    const message = parseStreamingServiceError(error.response.data);
    yield put(showErrorComponent({error:error, status:error?.response?.status ? error?.response?.status : 500}));
    yield put(goLiveFailure(message));

    const notificationMessage = getErrorNotificationMessage(message);
    yield put(createNotification(notificationMessage));
  }
}

function* liveStreamingChannelPayment(action) {
  try {
    const response = yield api.postMethod(
      "streaming_channel_payment_by_wallet",
      action.data
    );
    if (response.data.success) {
      yield put(liveStreamingChannelPaymentSuccess(response.data.data));
      yield put(setLiveStreamingChannelIsPaid(true));
      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );
      yield put(createNotification(notificationMessage));
    } else {
      yield put(liveStreamingChannelPaymentFailure(response.data.error));
      yield put(
        createNotification(getErrorNotificationMessage(response.data.error))
      );
    }
  } catch (error) {
    yield put(liveStreamingChannelPaymentFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* liveStreamingSummary(action) {
  try {
    const response = yield api.postMethod(
      "streaming_payment_summary_for_performer",
      action.data
    );
    if (response.data.success) {
      yield put(fetchLiveStreamingSummarySuccess(response.data.data));
    } else {
      yield put(fetchLiveStreamingSummaryFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(fetchLiveStreamingSummaryFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* fetchStreamerChannel(action) {
  try {
    const response = yield StreamingService.findChannelById(action.data);
    const { channel, messages } = response;
    yield put(fetchStreamerChannelSuccess(channel));
    yield put(setLiveStreamingChannelMessages(messages));
  } catch (error) {
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const message = parseStreamingServiceError(error.response.data);
    yield put(fetchStreamerChannelFailure(message));

    const notificationMessage = getErrorNotificationMessage(message);
    yield put(createNotification(notificationMessage));
  }
}

function* fetchLiveStreamingChannel(action) {
  try {
    const response = yield StreamingService.findChannelById(action.data);
    const { channel, messages, paid } = response;
    yield put(fetchStreamingChannelSuccess(channel));
    yield put(setLiveStreamingChannelMessages(messages));
    yield put(setLiveStreamingChannelIsPaid(paid ? true : false));
  } catch (error) {
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const message = parseStreamingServiceError(error.response.data);
    yield put(fetchStreamingChannelFailure(message));

    const notificationMessage = getErrorNotificationMessage(message);
    yield put(createNotification(notificationMessage));
  }
}

function* fetchLiveStreamingChannels(action) {
  try {
    const { q, type, page, cancelToken } = action.data;
    const response = yield StreamingService.findLiveStreamingChannels(
      type,
      q,
      page,
      cancelToken
    );
    yield put(fetchLiveStreamingChannelsSuccess(response));
  } catch (error) {
      if(error?.response?.status !== 400){
        yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
      }
    const message = parseStreamingServiceError(error.response.data);
    yield put(fetchLiveStreamingChannelsFailure(message));

    const notificationMessage = getErrorNotificationMessage(message);
    yield put(createNotification(notificationMessage));
  }
}

function* fetchLivePerformers(action) {
  try {
    const { q, type, page, cancelToken } = action.data;
    const response = yield StreamingService.findLivePerformers(
      type,
      q,
      page,
      cancelToken
    );
    yield put(fetchLivePerformersSuccess(response));
  } catch (error) {
      if(error?.response?.status !== 400){
        yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
      }
    const message = parseStreamingServiceError(error.response.data);
    yield put(fetchLivePerformersFailure(message));

    const notificationMessage = getErrorNotificationMessage(message);
    yield put(createNotification(notificationMessage));
  }
}

export default function* pageSaga() {
  yield all([yield takeLatest(GO_LIVE_START, goLive)]);
  yield all([
    yield takeLatest(FETCH_LIVE_STREAMING_SUMMARY_START, liveStreamingSummary),
  ]);
  yield all([
    yield takeLatest(
      LIVE_STREAMING_CHANNEL_PAYMENT_START,
      liveStreamingChannelPayment
    ),
  ]);
  yield all([
    yield takeLatest(FETCH_STREAMER_CHANNEL_START, fetchStreamerChannel),
  ]);
  yield all([
    yield takeLatest(
      FETCH_LIVE_STREAMING_CHANNEL_START,
      fetchLiveStreamingChannel
    ),
  ]);
  yield all([
    yield takeLatest(
      FETCH_LIVE_STREAMING_CHANNELS_START,
      fetchLiveStreamingChannels
    ),
  ]);
  yield all([
    yield takeLatest(
      FETCH_LIVE_PERFORMERS_START,
      fetchLivePerformers
    ),
  ]);
}
